<script lang="ts">
    import { goto } from "$app/navigation"
    import PopupBanner from "./PopupBanner.svelte"
    import PopupButtons from "./PopupButtons.svelte"
    import PopupExit from "./PopupExit.svelte"
    import PopupHeading from "./PopupHeading.svelte"
    import PopupIcon from "./PopupIcon.svelte"
    import PopupIconDivider from "./PopupIconDivider.svelte"
    import PopupParagraph from "./PopupParagraph.svelte"
</script>

<PopupBanner class="bg-amber-100 dark:bg-neutral-800">
    <PopupIconDivider>
        <div slot="icon">
            <PopupIcon icon={"circle-warning"}
                naked
            />
        </div>
        <PopupHeading><slot name="title" /></PopupHeading>
    </PopupIconDivider>
</PopupBanner>
<PopupParagraph><slot name="paragraph" /></PopupParagraph>
<PopupButtons><slot /></PopupButtons>
